import React from 'react';
import L from 'leaflet';
import { RadioGroup } from 'evergreen-ui';

type LayerType = {
  [key: string]: L.TileLayer | L.TileLayer.WMS
}

type MapViewSelectorProps = {
  mapInstance: L.Map | null,
  layers: LayerType,
  label: string
  defaultValue: string
  hasNoneValue?: boolean
}

export default function MapViewSelector({
  mapInstance, layers, label, defaultValue, hasNoneValue = false,
}: MapViewSelectorProps) {
  const [selectedLayer, setSelectedLayer] = React.useState(defaultValue);
  const [previous, setPrevious] = React.useState(defaultValue);

  const options = React.useMemo(() => {
    const params = [];
    if (hasNoneValue) {
      params.push({
        label: 'Не выбрано',
        value: 'none',
      });
    }
    Object.keys(layers as object).forEach((key) => {
      params.push({
        label: key,
        value: key,
      });
    });
    return params;
  }, [hasNoneValue, layers]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setPrevious(selectedLayer);
    setSelectedLayer(value);
  };

  React.useEffect(() => {
    if (mapInstance) {
      if (previous !== 'none') {
        mapInstance.removeLayer(layers[previous]);
      }
      if (selectedLayer !== 'none') {
        mapInstance.addLayer(layers[selectedLayer]);
      }
    }
  }, [layers, mapInstance, previous, selectedLayer]);

  return (
    <RadioGroup
      label={label}
      options={options}
      value={selectedLayer as string}
      onChange={onChange}
    />
  );
}
